import myRestClient from "./restClient";
import { ENV_NAME, ENCRYPTION_KEY, IV_LENGTH } from "../config";
import crypto from "crypto";

export async function getCompany(company_id) {
    const params = {
        id: company_id
    };
    const result = await myRestClient("GET_ONE", "companies", params).then(
        response => {
            return response.data;
        },
        err => {
            console.log(err);
            return null;
        }
    );
    return result;
}

export async function getCustomer(customer_id) {
    const params = {
        id: customer_id
    };
    const result = await myRestClient("GET_ONE", "customers", params).then(
        response => {
            return response.data;
        },
        err => {
            console.log(err);
            return null;
        }
    );
    return result;
}

export async function getInstallationTypeId(inst_codename) {
    const params = {
        codename: inst_codename
    };
    const result = await myRestClient(
        "GET_ONE_BY_PARAMETERS",
        "installation_types",
        params
    ).then(
        response => {
            if (response && response.data && response.data[0]) {
                return response.data[0].id;
            }
            return null;
        },
        err => {
            console.log(err);
            return null;
        }
    );
    return result;
}

export async function getInstallationType(inst_type_id) {
    const params = {
        id: inst_type_id
    };
    const result = await myRestClient(
        "GET_ONE",
        "installation_types",
        params
    ).then(
        response => {
            return response.data;
        },
        err => {
            console.log(err);
            return null;
        }
    );
    return result;
}

export function getAllInstallationTypes() {
    const params = {
        pagination: { page: 1, perPage: 10000 },
        sort: { field: "name", order: "asc" }
    };
    const result = myRestClient("GET_LIST", "installation_types", params).then(
        response => {
            return response.data;
        },
        err => {
            console.log(err);
            return null;
        }
    );
    return result;
}

export async function getLicenseName(lic_id) {
    const params = {
        id: lic_id
    };
    const result = await myRestClient("GET_ONE", "licenses", params).then(
        response => {
            return response.data.name;
        },
        err => {
            console.log(err);
            return null;
        }
    );
    return result;
}

export function isStaging() {
    return ENV_NAME === "staging";
}

export function encrypt(data) {
    const iv = crypto.randomBytes(IV_LENGTH);
    const cipher = crypto.createCipheriv(
        "aes-256-gcm",
        Buffer.from(ENCRYPTION_KEY),
        iv
    );
    let encrypted = cipher.update(data, "utf8", "hex");
    encrypted += cipher.final("hex");
    const authTag = cipher.getAuthTag().toString("hex");
    return iv.toString("hex") + ":" + encrypted + ":" + authTag;
}

export function decrypt(data) {
    const parts = data.split(":");
    const iv = Buffer.from(parts.shift(), "hex");
    const encryptedText = parts.shift();
    const authTag = Buffer.from(parts.shift(), "hex");
    const decipher = crypto.createDecipheriv(
        "aes-256-gcm",
        Buffer.from(ENCRYPTION_KEY),
        iv
    );
    decipher.setAuthTag(authTag);
    let decrypted = decipher.update(encryptedText, "hex", "utf8");
    decrypted += decipher.final("utf8");
    return decrypted;
}

export async function getMultiTenantAccesUrl(inst_type_id) {
    const params = {
        id: inst_type_id
    };
    const result = await myRestClient(
        "GET_ONE",
        "installation_types",
        params
    ).then(
        response => {
            return response.data.multi_tenant_access_url;
        },
        err => {
            console.log(err);
            return null;
        }
    );
    return result;
}

export async function getConfig() {
    const params = {
        id: 1
    };
    const result = await myRestClient("GET_ONE", "configs", params).then(
        response => {
            return response.data;
        },
        err => {
            console.log(err);
            return null;
        }
    );
    return result;
}

export async function getOperationParams(inst_type_id, opt_type) {
    let user_prompt = null;
    let data_db = null;

    // find operation type id
    const opt_type_id = await myRestClient(
        "GET_ONE_BY_PARAMETERS",
        "operation_types",
        {
            name: opt_type
        }
    ).then(
        res_opt_type => {
            return res_opt_type.data[0].id;
        },
        err => {
            console.log(err);
            return null;
        }
    );

    // read installation type params
    const params = await myRestClient("GET_ONE_BY_PARAMETERS", "operations", {
        installation_type_id: inst_type_id,
        operation_type_id: opt_type_id
    }).then(
        res_opt => {
            return res_opt.data[0].params;
        },
        err => {
            console.log(err);
            return null;
        }
    );

    // parse user_prompt params
    if (params) {
        const obj = JSON.parse(params);
        user_prompt = obj.filter(o => o.source === "user_prompt");
        data_db = obj.filter(o => o.source === "db");
    }
    return { user_prompt: user_prompt, data_db: data_db };
}



// WEBPACK FOOTER //
// ./src/common/utilities.js